import { render, staticRenderFns } from "./FMList.vue?vue&type=template&id=2bed735c&scoped=true"
import script from "./FMList.vue?vue&type=script&lang=js"
export * from "./FMList.vue?vue&type=script&lang=js"
import style0 from "./FMList.vue?vue&type=style&index=0&id=2bed735c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed735c",
  null
  
)

export default component.exports